import { Typography } from '@mui/material';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { msgTypes } from 'constants/msgTypes';
import { Form, Formik } from 'formik';
import { InvoiceManagementModel } from 'model/screensModels/InvoiceManagementModel';
import { MemberBankDetailsModel } from 'model/screensModels/MemberBankDetailsModel';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { RequestModel } from 'model/utilModels/RequestModel';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { InvoiceManagementSchema } from 'schemas/menu/invoiceManagementSchema/InvoiceManagementSchema';
import { LocalStorageService } from 'services/auth/LocalStorageService';
import { InvoiceManagementService } from 'services/menu/invoiceManagementService/InvoiceManagementService';
import { MemberBankDetailsService } from 'services/menu/memberBankDetailsService/MemberBankDetailsService';
import { UtilService } from 'services/shared/UtilService';
import './createInvoice.scss';

const CreateInvoice = ({ setFlag, updateRecord }) => {
  const [viewMode, setViewMode] = useState(false);
  const [initialValue, setInitialValue] = useState(new InvoiceManagementModel());
  const [newInvoice, setNewInvoice] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [memberBankDetailsList, setMemberBankDetailsList] = useState<MemberBankDetailsModel[]>([]);
  const [dateFlag, setDateFlag] = useState(undefined)
  const [currencyList, setCurrencyList] = useState([]);
  const [editInvoice, setEditInvoice] = useState(false);
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  })
  const InvoiceList = [
    { "key": msgTypes.INVOICE_STATUS.PAID, "value": msgTypes.INVOICE_STATUS.PAID },
    { "key": msgTypes.INVOICE_STATUS.OUTSTANDING, "value": msgTypes.INVOICE_STATUS.OUTSTANDING },
    // { "key": msgTypes.INVOICE_STATUS.OVERDUE, "value": msgTypes.INVOICE_STATUS.OVERDUE }
  ]

  const formikRef = useRef(null);
  const fileInputRef = useRef(null);


  useEffect(() => {
    getBankDetailsList();
    getCurrencyList();

  }, [])

  useEffect(() => {
    setValue();
  }, [updateRecord])

  const setValue = async () => {
    await loadCompany();
    if (updateRecord) {
      if (updateRecord?.invoiceId?.length === 0) {
        setEditInvoice(false);
        const invoiceId = await getInvoiceNumber();
        updateRecord.invoiceId = invoiceId;
        setNewInvoice(true);
      }else{
        setEditInvoice(true);
      }
      setInitialValue(updateRecord)
      isInwardInvoice(updateRecord);
    }
  }

  const isInwardInvoice = async (updateRecord) => {
    const userDetails = JSON.parse(await LocalStorageService.getUserDetails());
    if (userDetails.companyId === updateRecord.toCompanyId) {
      setViewMode(false)
    }
  }

  const getInvoiceNumber = async () => {
    const res = await InvoiceManagementService.getInvoiceNumber();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        return res.data;
      } else {
        return '';
      }
    }
  }

  const loadCompany = async () => {
    const res = await UtilService.getCompanyList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setCompanyList(res.data);
      } else {
        setCompanyList([]);
      }
    }
  }

  //load Currency
  const getCurrencyList = async () => {
    const res = await UtilService.getCurrencyList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setCurrencyList(res.data);
    }
  };

  //Prepare request body to get blog list
  const prepareRequest = async () => {
    const requestBody = new RequestModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = 50;//pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    const userDetails = JSON.parse(await LocalStorageService.getUserDetails());
    requestBody.companyId = userDetails.companyId;
    return requestBody;
  }

  //Get Member Bank Details list
  const getBankDetailsList = async () => {
    const requestBody = await prepareRequest();
    const res = await MemberBankDetailsService.getBankDetails(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        if (res.data?.tbody?.length > 0) {
          setMemberBankDetailsList(res?.data?.tbody);
        } else {
          setMemberBankDetailsList([]);
        }
      } else {
        setMemberBankDetailsList([]);
      }
    }
  }

  //Prepare Data for API
const prepareRequestBody = async (values: InvoiceManagementModel): Promise<InvoiceManagementModel> => {
  const loginDetails = JSON.parse(await LocalStorageService.getUserDetails());

  const prepareData = {
    invoiceId: ("" + initialValue.invoiceId)?.length > 0 ? initialValue.invoiceId : (values.invoiceId || ''),
    fromCompanyId: loginDetails.companyId,
    toCompanyId: values.toCompanyId || '',
    subject: values.subject || '',
    status: values.status || '',
    uploadedInvoice: values.uploadedInvoice || '',
    amount: values.amount || '',
    currency: values.currency || '',
    bankId: values.bankId || '',
    paidDate: values.paidDate || '',
    dueDate: values.dueDate || ''
  };

  return prepareData as InvoiceManagementModel;
};


  const addInvoice = async (values: InvoiceManagementModel) => {
    const requestData = await prepareRequestBody(values);
    // console.log("requestData is", requestData)
    const res = await InvoiceManagementService.addInvoice(requestData);
    // console.log("response add invoice",res)
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if(!editInvoice){
          formikRef.current.resetForm();
          const invoiceId = await getInvoiceNumber();
          //formikRef.current.setFieldValue('invoiceId', invoiceId);
          updateRecord.invoiceId = invoiceId;
          formikRef.current.setFieldValue('imageFile', null);
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
      }else{
        setFlag(false);
        formikRef.current.resetForm();
        formikRef.current.setFieldValue('imageFile', null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }

      return true
    } else {
      return false
    }
  }

  const invoiceStatusChange = (selectedStatus) => {
    if (selectedStatus !== null) {
      if (selectedStatus.value === msgTypes.INVOICE_STATUS.PAID) {
        setDateFlag(true)
      } else {
        setDateFlag(false)
      }
    } else {
      setDateFlag(undefined)
    }

  }

  const BankDetails = ({ bankDetails }) => {
    return (

      <div className='card border-0'>
        <div className='card-body'>
          <Typography>
            <div className='recent-col'>
              <h5><span ></span>Account Holder Name: <span className="bank-text text-sm ms-sm-2">{bankDetails.accountHolderName}</span></h5>
            </div>
          </Typography>
          <Typography>
            <div className='recent-col'>
              <h5> Bank Name: <span className="bank-text text-sm ms-sm-2">{bankDetails.bankName}</span></h5>
            </div>
          </Typography>
          <Typography>
            <div className='recent-col'>
              <h5><span ></span>Currency: <span className="bank-text text-sm ms-sm-2">{bankDetails.currency}</span></h5>
            </div>
          </Typography>
          <Typography>
            <div className='recent-col'>
              <h5><span ></span>  Swift Code: <span className="bank-text text-sm ms-sm-2">{bankDetails. swiftCode}</span></h5>
            </div>
          </Typography>
          <Typography>
            <div className='recent-col'>
              <h5><span ></span>  Routing No: <span className="bank-text text-sm ms-sm-2">{bankDetails. routingNo}</span></h5>
            </div>
          </Typography>
          <Typography>
            <div className='recent-col'>
              <h5><span ></span>  Country: <span className="bank-text text-sm ms-sm-2">{bankDetails.countryName}</span></h5>
            </div>
          </Typography>

          <Typography>
            <div className='recent-col'>
              <h5><span ></span>  Branch Name: <span className="bank-text text-sm ms-sm-2">{bankDetails.branchName}</span></h5>
            </div>
          </Typography>

    
          <Typography>
            <div className='recent-col'>
              <h5>IBAN NO: <span className="bank-text text-sm ms-sm-2">{bankDetails.iban}</span></h5>
            </div>
          </Typography>
          <Typography>
            <div className='recent-col'>
              <h5>Account Number: <span className="bank-text text-sm ms-sm-2">{bankDetails.accountNumber}</span></h5>
            </div>
          </Typography>
          <Typography>
            <div className='recent-col'>
              <h5> Type: <span className="bank-text text-sm ms-sm-2">{bankDetails.type}</span></h5>
            </div>
          </Typography>
        </div>
      </div>

    )
  }

  const formattedCurrencyList = currencyList.map(item => ({
    ...item,
    displayName: `${item.country} - ${item.currency}`,
  }));
  return (
    <>
      <div className='createinvoice-card'>
        <Formik
          enableReinitialize={true}
          initialValues={initialValue}
          validationSchema={InvoiceManagementSchema}
          onSubmit={async (values, { resetForm }) => {
            const res = await addInvoice(values);
            if (res) {
              resetForm();
            }
          }}
          innerRef={formikRef}
        >
          {
            ({ isValid, setFieldValue, dirty, isSubmitting, values }) => (
              <>
                <Form>
                  <div className='container'>

                    <div className='row card--'>
                      <div className='col-lg-4 position-relative facts-one'>
                        <div className='sub-content-sec'>

                          {/* <BankList /> */}
                          <FormikControl
                            className="radiobutton"
                            control="radiogroup"
                            label="Choose your Bank"
                            name="bankId"
                            requiredField
                            options={memberBankDetailsList?.map((bankDetails: MemberBankDetailsModel, index) => {
                              return { key: <BankDetails bankDetails={bankDetails} />, value: bankDetails.bankId }
                            })}
                            disabled={viewMode}
                          />
                        </div>
                      </div>
                      <div className='col-lg-8 position-relative facts-two'>
                        <div className='sub-content-sec'>
                          {/*Begin:: Add invoice form */}
                          <div className='container p-3'>
                          {editInvoice===true && (
                                <div className='row'>
                                <div className='col-lg-4 col-md-4' >
                                  <FormikControl control='textfield'
                                    name='invoiceId'
                                    label="Invoice Number"
                                    placeholder=""
                                    disabled={true}
                                  />
                                </div>
                              </div>
                            )}
                            
                            <div className='row'>
                              <div className="col-lg-6 col-md-6 position-relative">
                                <FormikControl control='autocomplete'
                                  name="toCompanyId"
                                  label="Company Name"
                                  options={companyList}
                                  keyfield="companyName"
                                  valuefield="companyId"
                                  requiredField
                                  disabled={viewMode}
                                />
                              </div>

                              <div className="col-lg-6 col-md-6 position-relative">
                                <FormikControl
                                  control='autocomplete'
                                  name="status"
                                  label="Invoice Status"
                                  placeholder="Choose invoice status"
                                  onChange={(value) => { invoiceStatusChange(value) }}
                                  requiredField
                                  options={InvoiceList}
                                  keyfield="key"
                                  valuefield="value"
                                  disabled={viewMode}
                                />
                              </div>

                            </div>

                            <div className='row'>
                              <div className="col-lg-6 col-md-6 position-relative">
                                <FormikControl control='textfield'
                                  name='amount'
                                  label="Amount"
                                  placeholder="Enter Amount"
                                  requiredField
                                  disabled={viewMode}
                                />
                              </div>

                              <div className="col-lg-6 col-md-6 position-relative">
                                <FormikControl
                                  control="autocomplete"
                                  name="currency"
                                  label="Currency"
                                  placeholder="Select currencey"
                                  requiredField
                                  options={formattedCurrencyList}
                                  keyfield="displayName"
                                  valuefield="code"
                                  disabled={viewMode}
                                />
                              </div>

                            </div>

                            <div className='row'>
                              <div className="col-lg-6 col-md-6 position-relative">
                                <FormikControl control='datepicker'
                                  name='paidDate'
                                  label="Paid Date"
                                  placeholder="Select Paid Date"
                                  requiredField
                                  disabled={(!dateFlag || dateFlag === undefined) || viewMode}
                                />
                              </div>

                              <div className="col-lg-6 col-md-6 position-relative">
                                <FormikControl control='datepicker'
                                  name='dueDate'
                                  label="Due Date"
                                  placeholder="Select Due Date"
                                  requiredField
                                  disabled={(dateFlag || dateFlag === undefined) || viewMode}
                                />
                              </div>

                            </div>

                            <div className='row'>
                              <div className="col-lg-12 col-md-12 position-relative">
                                <FormikControl control='textfield'
                                  name="subject"
                                  label="Subject"
                                  placeholder="Enter subject"
                                  // requiredField
                                  multiline={true}
                                  rows={4}
                                  disabled={viewMode}
                                />
                              </div>

                            </div>


                            <div className='row'>
                              <div className="col-lg-6 col-md-6 position-relative">
                                <FormikControl control='uploadImage'
                                  // requiredField
                                  name="uploadedInvoiceFile"
                                  label="Upload invoice"
                                  nameUrl="uploadedInvoice"
                                  disabled={viewMode}
                                  requiredField
                                  tooltip = {[msgTypes.DOCUMENT_TYPE.PDF,msgTypes.FILE_SIZE_ALLOW_3MB]}
                                  inputRef={fileInputRef}
                                />
                              </div>

                            </div>

                            {!viewMode ?
                              <div className='col-12 d-flex justify-content-end'>
                                <FormikControl control='button' className="btn btn-submit" color="primary" label={newInvoice === true ? "Save" : "Update"} type="submit" disabled={!dirty || !isValid} />&nbsp;&nbsp;
                                <FormikControl control='button' className="btn btn-cancel" color="warning" label="Back" type="reset" onClick={() => { setFlag(false) }} />
                              </div>
                              :
                              (
                                <div className='col-12 d-flex justify-content-end'>
                                 &nbsp;&nbsp; <FormikControl control='button' className="btn btn-cancel" color="warning" label="Back" type="reset" onClick={() => { setFlag(false) }} />
                                </div>
                              )}
                          </div>
                        </div>
                        {/*End:: Add invoice form */}


                      </div>
                    </div>
                  </div>

                </Form>
              </>

            )
          }
        </Formik>
      </div >
    </>
  )
}
export default CreateInvoice;


